import BotStore from '@src/store';
import * as Api from './api';

export const getPortals = () => {
  return Api.fetchPortals();
};

export const getBrands = (params) => {
  return Api.fetchBrands(params);
};

export const getDepartments = (params) => {
  return Api.fetchDepartments(params);
};

export const getAuthoriseURL = () => {
  return Api.fetchAuthoriseURL();
};

export const getTokens = () => {
  return Api.fetchTokens();
};

export const createBot = (appId, departmentIds, screenName, webhookUrl) => {
  const wwIva = JSON.parse(localStorage.getItem('ww_iva'));
  let botName = wwIva?.isSmartSkill ? wwIva?.domain_name : wwIva?.title;
  const env = BotStore.getEnvironment();
  if (env === 'staging') {
    botName = `${botName} ${env}`;
  }
  const request = {
    name: botName,
    description: 'Bot Created by Haptik',
    webhook: {
      url: webhookUrl,
      secured: 'true',
    },
    published: 'false',
    vendor: {
      console_url: 'https://irobo.com/developerconsole',
      version: '1.0.0',
    },
    connector: 'webhook',
    app_id: appId,
    department_ids: departmentIds,
    handoff_enabled: 'false',
    typing_delay: '2',
  };
  if (BotStore.isProductionEnv()) {
    const prodRequest = {
      webhook: {
        production_url: webhookUrl,
      },
      published: true,
    };
    return Api.updateBot(prodRequest);
  }
  return Api.createBot(request, screenName);
};
